import axios from 'Helpers/axios-helper';

import {
  GET_CATALOG_ITEMS,
  GET_FILTERED_ITEMS,
  // SET_ACTIVE_FILTER,
  // FILTER_BY_CATEGORY,
  // UPDATE_FILTERED_RESULTS,
  GET_CATEGORIES,
  GET_FILTERED_AUTHORS,
  GET_CATALOG_LOCALSTORAGE,
  SET_CATALOG_LOCALSTORAGE,
} from './mutations';

const actions = {
  [GET_CATALOG_ITEMS]({ commit, state }) {
    axios.get(state.API_SEARCH_ENDPOINT).then(({ data }) => {
      commit({ type: GET_CATALOG_ITEMS, data });
    });
  },

  [GET_CATEGORIES]({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios
        .get(state.API_CATEGORY_ENDPOINT)
        .then(({ data }) => {
          commit({ type: GET_CATEGORIES, data });
          resolve(data);
        })
        .catch(reject);
    });
  },

  [SET_CATALOG_LOCALSTORAGE]({ commit, state }) {
    if (state.activeCatalog == 'perform') {
      const performStore = {
        activeAttributes: state.activeAttributes,
        activeCategory: state.activeCategory,
        activeCastSize: state.activeCastSize,
        searchTerm: state.searchTerm,
      };
      sessionStorage.removeItem('performStore');
      sessionStorage.setItem('performStore', JSON.stringify(performStore));
    } else if (state.activeCatalog == 'shop') {
      const shopStore = {
        activeAttributes: state.activeAttributes,
        activeCategory: state.activeCategory,
        activeCastSize: state.activeCastSize,
        searchTerm: state.searchTerm,
      };
      sessionStorage.removeItem('shopStore');
      sessionStorage.setItem('shopStore', JSON.stringify(shopStore));
    } else if (state.activeCatalog == 'authors') {
      const authorStore = {
        activeCategory: state.activeCategory,
        searchTerm: state.searchTerm,
      };
      sessionStorage.removeItem('authorStore');
      sessionStorage.setItem('authorStore', JSON.stringify(authorStore));
    }

    commit({ type: SET_CATALOG_LOCALSTORAGE });
  },

  [GET_CATALOG_LOCALSTORAGE]({ commit, state }) {
    let storedFilters = null;
    if (state.activeCatalog == 'perform') {
      storedFilters = sessionStorage.getItem('performStore');
    } else if (state.activeCatalog == 'shop') {
      storedFilters = sessionStorage.getItem('shopStore');
    } else if (state.activeCatalog == 'authors') {
      storedFilters = sessionStorage.getItem('authorStore');
    }

    if (storedFilters !== null) {
      const parsed = JSON.parse(storedFilters);
      const parsedFilters =
        typeof parsed.activeAttributes !== 'undefined'
          ? parsed.activeAttributes
          : [];
      const parsedCategory = parsed.activeCategory;
      const parsedCastSize = parsed.activeCastSize;
      const parsedSearchTerm = parsed.searchTerm;
      commit({
        type: GET_CATALOG_LOCALSTORAGE,
        payload: {
          // currentCatalog,
          parsedFilters,
          parsedCategory,
          parsedCastSize,
          parsedSearchTerm,
        },
      });
    }
  },

  [GET_FILTERED_ITEMS]({ commit, state, getters }) {
    commit({ type: 'setLoading', payload: true });

    return new Promise((resolve, reject) => {
      const currentParams = Object.fromEntries(new URLSearchParams(window.location.search).entries());

      const attributes =
        state.activeAttributes.length < 1
          ? null
          : state.activeAttributes.map(option => option.Id).join(',');

      const params = {
        attributes: attributes,
        orderBy: state.sortBy,
        author: state.author,
        pageSize: state.perPage,
        includePrice: state.includePrice,
        includeAuthors: state.includeAuthors,
        includeCategories: state.includeCategories,
        setCacheApi: state.setCacheApi,
        catalogId: currentParams.catalogId || state.activeCategory.Id,
        categoryId: currentParams.catalogId || state.activeCategory.Id,
        pageNumber: state.currentPage - 1 > 0 ? state.currentPage - 1 : 0,
        query: state.searchTerm || null,
      };

      if (state.activeCastSize.length > 0) {
        const castingCases = Object.entries(getters.castingSizeMap);

        castingCases.forEach(([id, name]) => {
          const minMaxCastingValues = name === 'total' ? getters.totalCastingSizeMinMax : getters.castingSizeMinMax;
          const option = state.activeCastSize.find(({ Id }) => Id === id);
          if (option) {
            if (option.Size.min >= minMaxCastingValues[0]) {
              params[`${name}Min`] = option.Size.min;
            }
            if (params[`${name}Min`] || minMaxCastingValues[1]) {
              params[`${name}Max`] = option.Size.max === minMaxCastingValues[1] ? 999 : option.Size.max;
            }
          }
        });
      }

      axios
        .get(state.API_SEARCH_ENDPOINT, params)
        .then(({ data }) => {
          commit({ type: GET_FILTERED_ITEMS, data });
          commit({ type: 'setLoading', payload: false });

          if(location.pathname === '/shop/catalog' || location.pathname === '/perform/catalog') {
            // Only allow these 5 parameters in the query string
            const params = {
              pageNumber: state.currentPage ? state.currentPage - 1 : 0,
              keyword: state.searchTerm,
              catalogId: currentParams.catalogId || state.activeCategory.Id,
              sortBy: state.sortBy,
              author: state.author ? state.author : 0,
            }

            // Remove any blank (or 0) values
            Object.keys(params).forEach((key) => (params[key] == 0) && delete params[key]);

            const queryString = new URLSearchParams(params).toString();
            const url = location.pathname + '?' + queryString;
            window.history.replaceState(data, 'test', url);
          }
          resolve();
        })
        .catch(reject);
    });
  },

  [GET_FILTERED_AUTHORS]({ commit, state }) {
    commit({ type: 'setLoading', payload: true });

    return new Promise((resolve, reject) => {
      const params = {
        query: state.searchTerm || null,
        categoryId: state.activeCategory.Id === 0 ? null : state.activeCategory.Id,
        pageNumber: state.currentPage,
        pageSize: state.perPage,
      };

      axios
        .get(state.API_SEARCH_ENDPOINT, params)
        .then(({ data }) => {
          commit({ type: GET_FILTERED_AUTHORS, data });
          commit({ type: 'setLoading', payload: false });
          resolve();
        })
        .catch(reject);
    });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/catalog/actions.js